import { render, staticRenderFns } from "./inputContractedSyntaxWidget.vue?vue&type=template&id=66c5239e&scoped=true&"
import script from "./inputContractedSyntaxWidget.vue?vue&type=script&lang=js&"
export * from "./inputContractedSyntaxWidget.vue?vue&type=script&lang=js&"
import style0 from "./inputContractedSyntaxWidget.vue?vue&type=style&index=0&id=66c5239e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c5239e",
  null
  
)

export default component.exports